import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{staticClass:"pa-3"},[_c(VSpacer),_c(VAvatar,{staticClass:"mr-1",attrs:{"size":"20px","tile":""}},[_c(VImg,{attrs:{"src":_vm.ecsArrow,"contain":""}})],1),_c('div',{staticClass:"caption mr-1"},[_vm._v(" "+_vm._s(_vm.appVersion)+" ")]),_c('div',{staticClass:"caption"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" The ECS Group")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }